export const EquipmentChargeType = {
    null: "NULL",
    time: "TIME",
    hour: "HOUR",
} as const;

export type EquipmentChargeType = typeof EquipmentChargeType[keyof typeof EquipmentChargeType];

export const EquipmentChargeTypeString = {
    null: "無料機材",
    time: "1回につき",
    hour: "1時間につき",
}

export const EquipmentChargeTypeStringOfValue = {
    "NULL": "無料機材",
    "TIME": "1回につき",
    "HOUR": "1時間につき",
}
export interface EquipmentData {
    equ_id?: number
    str_id?: number
    equcate_id?: number
    equ_name?: string
    equ_charge?: number
    equ_charge_type?: EquipmentChargeType
    equ_maker?: string
    equ_model?: string
    equ_shortened?: string
    equgrp_id?: number
    equgrp_name?: string
    free_flug?: boolean
    rental_flug?: boolean
    repaired_flug?: boolean
    delete_flug?: boolean
    available_studio_ids?: number[]
}

export interface ObjectToEquipmentDataProps {
    equ_id?: number | string
    str_id?: number | string
    equcate_id?: number | string
    equ_name?: string
    equ_charge?: number | string
    equ_charge_type?: string
    equ_maker?: string
    equ_model?: string
    equ_shortened?: string
    equgrp_id?: number | string
    equgrp_name?: string
    free_flug?: boolean | string
    rental_flug?: boolean | string
    repaired_flug?: boolean | string
    delete_flug?: boolean | string
    available_studio_list?: object[]
}

export const ObjectToEquipmentData = (obj: ObjectToEquipmentDataProps) => {
    let equ_charge_type: EquipmentChargeType | undefined = undefined
    switch (obj.equ_charge_type) {
        case EquipmentChargeType.hour:
        case EquipmentChargeType.time:
            equ_charge_type = obj.equ_charge_type as EquipmentChargeType
            break;
        default:
            equ_charge_type = EquipmentChargeType.null
            break;
    }
    return {
        equ_id: typeof obj.equ_id == 'string' ? parseInt(obj.equ_id) : obj.equ_id,
        str_id: typeof obj.str_id == 'string' ? parseInt(obj.str_id) : obj.str_id,
        equcate_id: typeof obj.equcate_id == 'string' ? parseInt(obj.equcate_id) : obj.equcate_id,
        equ_name: obj.equ_name,
        equ_charge: typeof obj.equ_charge == 'string' ? parseInt(obj.equ_charge) : obj.equ_charge,
        equ_charge_type: equ_charge_type,
        equ_maker: obj.equ_maker,
        equ_model: obj.equ_model,
        equ_shortened: obj.equ_shortened,
        equgrp_id: typeof obj.equgrp_id == 'string' ? parseInt(obj.equgrp_id) : obj.equgrp_id,
        equgrp_name: obj.equgrp_name,
        free_flug: typeof obj.free_flug == 'string' ? (obj.free_flug == "1" ? true : false) : obj.free_flug,
        rental_flug: typeof obj.rental_flug == 'string' ? (obj.rental_flug == "1" ? true : false) : obj.rental_flug,
        repaired_flug: typeof obj.repaired_flug == 'string' ? (obj.repaired_flug == "1" ? true : false) : obj.repaired_flug,
        delete_flug: typeof obj.delete_flug == 'string' ? (obj.delete_flug == "1" ? true : false) : obj.delete_flug,
        available_studio_ids: Array.isArray(obj.available_studio_list) ? obj.available_studio_list.map((item: any) => parseInt(item.std_id)) : undefined,
    }
}